import _Vue from 'vue'
import axios, { AxiosRequestConfig } from 'axios'
import VueCookies from 'vue-cookies'
import _router from 'vue-router'

interface RouterInterface {
  push(path: string): void
}

export default {
  install(Vue: typeof _Vue, router: typeof _router): void {
    // ログインや認証不要な場合のAPI
    const http = this.initAxios()
    // 認証情報付きのAPI
    const httpWithToken = this.initAxios()

    httpWithToken.interceptors.request.use((request: AxiosRequestConfig) => {
      // 認証情報の取得
      const auth = (VueCookies as any).get('authAcbt')
      if (auth && auth.accessToken != request.headers['access-token']) {
        request.headers['access-token'] = auth.accessToken
        request.headers.client = auth.client
        request.headers.uid = auth.uid
      }
      return request
    })

    // todo 認証後のWeb APIでリダイレクトや共通して処理したい場合はこちらに記述を追加
    httpWithToken.interceptors.response.use(
      (reponse: any) => reponse,
      async (error: any) => {
        // router.push等によりローディング処理が残っているケースがあるため処理を追加
        // Vue.prototype.$loading.complete()

        if (!error.response) {
          return alert('接続障害が発生しております。しばらくしてから接続してください。')
        }

        // responseTypeがblobの時にerror.response.dataをjsonに書き換える
        await this.onBlobHandler(error).catch(() => {
          ;((router as unknown) as RouterInterface).push('/error/error500')
        })

        if (error.response.status === 401) {
          // 現在の画面を開くために必要な認証画面を表示する
          const currentRoute = (router as any).currentRoute

          // HogeAuthedLayout.vueの処理で既に認証画面へ遷移済みの場合がある。
          // その場合は遷移させない。
          if (['/student/login', '/branch/login', '/academy/login', '/admin/login'].includes(currentRoute.fullPath)) {
            return
          }

          let layout = ''
          if (currentRoute.meta) {
            layout = currentRoute.meta.layout || ''
          }
          let path: string
          switch (layout) {
            case 'student-authed':
              path = '/student/login'
              break
            case 'branch-authed':
              path = '/branch/login'
              break
            case 'academy-authed':
              path = '/academy/login'
              break
            case 'admin-authed':
              path = '/admin/login'
              break
            default:
              path = '/'
              break
          }
          ;((router as unknown) as RouterInterface).push(path)
        } else if (error.response.status === 404 && error.response.data.code !== 40401) {
          ;((router as unknown) as RouterInterface).push('/error/error404')
        } else if (error.response.status === 500) {
          ;((router as unknown) as RouterInterface).push('/error/error500')
        }
        return Promise.reject(error)
      }
    )

    Vue.prototype.$http = { http, httpWithToken }
  },

  async onBlobHandler(error: any): Promise<any> {
    if (error.request.responseType === 'blob' && error.response.data instanceof Blob) {
      const text = await new Promise((resolve, reject) => {
        const fileReader = new FileReader()

        fileReader.onerror = () => {
          fileReader.abort()
          reject()
        }
        fileReader.onload = () => {
          resolve(fileReader.result)
        }

        fileReader.readAsText(error.response.data)
      })
      // @ts-ignore
      error.response.data = JSON.parse(text)
    }
    return
  },

  initAxios(): any {
    return axios.create({
      baseURL: process.env.VUE_APP_WEB_API_URL,
      timeout: 180000,
      headers: {
        'Content-Type': 'application/json',
        'X-Language': 'ja',
      },
    })
  },
}

// ? 各画面で言語を変更する場合はAPI前に下記のように設定
// ? Vue.prototype.$http.http.defaults.headers['X-Language'] = 'en'
